import type {
  BusinessRequirement,
  BusinessRequirementMetadataOptionItem,
  BusinessRequirementMetadataValue,
} from "../types";

/** Free-text remarks: API uses `reqRemarks`; forms use `reqRemark`. */
export function getBusinessRequirementRemarks(req: BusinessRequirement): string {
  const a = req.reqRemark;
  const b = req.reqRemarks;
  if (typeof a === "string" && a.length > 0) return a;
  if (typeof b === "string" && b.length > 0) return b;
  if (typeof a === "string") return a;
  if (typeof b === "string") return b;
  return "";
}

export function getBusinessRequirementEnum(
  value: BusinessRequirementMetadataValue,
): string {
  if (value == null) return "";
  if (typeof value === "string") return value;
  return value.enum ?? "";
}

export function getBusinessRequirementLabel(
  value: BusinessRequirementMetadataValue,
): string {
  if (value == null) return "";
  if (typeof value === "string") return value;
  return value.label ?? value.enum ?? "";
}

export function getBusinessRequirementLabelResolved(
  value: BusinessRequirementMetadataValue,
  options: BusinessRequirementMetadataOptionItem[],
): string {
  if (value == null) return "";
  if (typeof value === "string") {
    const found = options.find((o) => o.enum === value);
    return found ? found.label : value;
  }
  return value.label ?? value.enum ?? "";
}

export function getBusinessRequirementId(req: BusinessRequirement): number | undefined {
  return req.busReqId ?? req.reqId;
}

export function formatBusinessRequirementId(
  id: number | undefined | null,
): string {
  if (id == null) return "BR-—";
  return `BR-${id}`;
}

export const BUSINESS_REQUIREMENT_STATUS_DRAFT = "DRAFT";
export const BUSINESS_REQUIREMENT_STATUS_OPEN = "OPEN";
export const BUSINESS_REQUIREMENT_STATUS_DELETED = "DELETED";
export const BUSINESS_REQUIREMENT_STATUS_APPROVED = "APPROVED";
export const BUSINESS_REQUIREMENT_SOURCE_AI = "AI";
export const BUSINESS_REQUIREMENT_SOURCE_USER = "USER";

export const ORIGIN_DOC_TYPE_OPTIONS: BusinessRequirementMetadataOptionItem[] = [
  { enum: "RFP", label: "RFP" },
  { enum: "RFP_ANALYSIS", label: "RFP Analysis" },
  { enum: "MEETING_MINUTES", label: "Meeting Minutes" },
  { enum: "OTHER", label: "Other" },
];

export const ORIGIN_DOC_TYPE_OPTIONS_AI = ORIGIN_DOC_TYPE_OPTIONS.filter(
  (o) => o.enum !== "OTHER",
);

export function statusOptionsFromMetadata(
  options: BusinessRequirementMetadataOptionItem[],
  enums: string[],
): { value: string; label: string }[] {
  const allow = new Set(enums.map((e) => e.toUpperCase()));
  return options
    .filter((o) => allow.has(o.enum.toUpperCase()))
    .map((o) => ({ value: o.enum, label: o.label }));
}
